var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    viewBox: "0 0 24.19 27.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash-can-solid",
    d: "M7.3.956A1.721,1.721,0,0,1,8.844,0h6.5A1.721,1.721,0,0,1,16.89.956l.389.772h5.184a1.728,1.728,0,1,1,0,3.456H1.728a1.728,1.728,0,1,1,0-3.456H6.911ZM1.728,6.911H22.462V24.19a3.459,3.459,0,0,1-3.456,3.456H5.184A3.459,3.459,0,0,1,1.728,24.19Zm5.184,3.456a.866.866,0,0,0-.864.864V23.326a.864.864,0,1,0,1.728,0V11.231A.866.866,0,0,0,6.911,10.367Zm5.184,0a.866.866,0,0,0-.864.864V23.326a.864.864,0,1,0,1.728,0V11.231A.866.866,0,0,0,12.1,10.367Zm5.184,0a.866.866,0,0,0-.864.864V23.326a.864.864,0,1,0,1.728,0V11.231A.866.866,0,0,0,17.279,10.367Z",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.098ce8c10aea549e1f35798a173af3d9.svg";
export { ForwardRef as ReactComponent };